<template>
    <transition>
        <div class="menu" :class="{ active, 'is-bottom': bottom }">
            <a
                v-if="!bottom"
                class="menu-close show-mobile"
                @click="() => $emit('update:active', false)"
            >
                &times;
            </a>
            <div class="menu-side-left">
                <img src="@/assets/img/svg/white_logo.svg" width="196" />
                <social-networks icon-width="25"></social-networks>
                <a
                    class="button button-white is-outlined"
                    href="https://api.whatsapp.com/send?phone=551133760100"
                    target="_blank"
                >
                    <img
                        src="@/assets/img/svg/white_whatsapp.svg"
                        width="30"
                        class="icon"
                    />
                    <span>ENVIE UMA MENSAGEM</span>
                </a>
                <br />
                <br />
                <br />
                <router-link
                    :to="{ name: 'page_online_scheduling' }"
                    class="button button-white is-outlined"
                >
                    <img
                        class="icon"
                        src="@/assets/img/svg/white_calendar.svg"
                    />
                    AGENDAMENTO ONLINE
                </router-link>
            </div>
            <div class="menu-side-right">
                <ul>
                    <li
                        v-for="item in links"
                        :key="`menu-link-${item.name}`"
                        v-once
                    >
                        <router-link
                            :to="item.to"
                            :class="{ active: $route.name === item.to.name }"
                            >{{ item.title }}</router-link
                        >
                    </li>
                </ul>
            </div>
        </div>
    </transition>
</template>

<script>
import SocialNetworks from "./SocialNetworks";

export default {
    props: ["active", "bottom"],

    components: { SocialNetworks },
    computed: {
        links() {
            return [
                { to: { name: "home" }, title: "Home" },
                { to: { name: "blog" }, title: "Diké - Blog Jurídico" },
                {
                    to: { name: "page_expertise_area" },
                    title: "Áreas de Atuação"
                },
                { to: { name: "page_about" }, title: "Sobre Nós" },
                { to: { name: "page_team" }, title: "Equipe" },
                {
                    to: { name: "page_work_with_us" },
                    title: "Trabalhe Conosco"
                },
                { to: { name: "page_contact" }, title: "Contato" }
            ];
        }
    },

    watch: {
        active(active) {
            document.body.classList[active ? "add" : "remove"]("menu-opened");
        },

        $route() {
            this.$emit("update:active", false);
        }
    },

    beforeDestroy() {
        document.body.classList.remove("menu-opened");
    }
};
</script>
